import axios from "axios";

const getCustomizeReportingSummary = async (params = {}) => {
  try {
    const response = await axios.post(
      "/distributor/system-admin/summary/v1/data-summary/customize-reporting-summary",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch customize reporting summary:", error);
    throw error.response?.data || error;
  }
};

export default getCustomizeReportingSummary;
